import { isEmpty } from 'es-toolkit/compat';

import type { ResourceUsage } from '../redux/types';

export function calculatePriceForResources(enrichedResourceUsages: ResourceUsage[]): number | undefined {
    if (isEmpty(enrichedResourceUsages)) {
        return;
    }
    // allowed because we validate for isNaN in line below
    // biome-ignore lint/style/noNonNullAssertion: TODO: review this suppression
    const triedSum = enrichedResourceUsages.map(resourceUsage => resourceUsage.price! * 100).reduce((a, b) => a + b, 0);
    return Number.isNaN(triedSum) ? undefined : Math.round(triedSum) / 100;
}
